<template>
    <section>
      <div style="padding-top: 22px">

        <div class="hero is-bold">
          <div class="hero-body" style="padding-left: 0px; padding-top: 0px">
            <div >
              <h1 class="title" style="color:#3e8ed0">Devices</h1>
              <h5 class="subtitle">Manage your devices here. Each device can be assigned to a single cluster.<br>
              <div style="color:#bfbfbf; font-size: medium; padding-top: 5px;">Note: Regarding device status option, it is is only available for app versions 6.5 and higher.</div></h5>
            </div>
          </div>
        </div>
        <b-table :data="tableData" striped>
          <template slot-scope="props">
            <b-table-column field="name" label="Device name" style="padding-top: 14px">
              {{props.row.name}}
            </b-table-column>
            <b-table-column field="id" label="UID" centered style="padding-top: 14px">
              {{props.row.id}}
            </b-table-column>
            <b-table-column field="clusterId" label="Cluster" centered>
              <b-select :disabled="(role !== 'admin' && role !== 'device' && isMigrated)" @change.native="changeDeviceCluster($event, props.row.id)"
                v-model="selectedClusters[props.row.id]">
                <option value=''>---None---</option>
                <option v-for="(cluster, id) of clusters" :key="id" :value="id">
                  {{cluster.name}}
                </option>
              </b-select>
            </b-table-column>
            <b-table-column field="powerDevice" label="Power device" v-if="addOns.powerDevices" centered>
              <b-select :disabled="role !== 'admin' && role !== 'device' && isMigrated" @change.native="changePowerDevice($event, props.row.id)"
              v-model="selectedPowerDevices[props.row.id]">
                <option value=''>---None---</option>
                <option v-for="(powerDevice, id) of powerDevices" :key="id" :value="powerDevice.id">
                  {{powerDevice.name}}
                </option>
              </b-select>
            </b-table-column>
            <b-table-column field="id" label="App version" centered style="padding-top: 14px">
              {{props.row.currentAppVersion}}
            </b-table-column>
            <b-table-column label="Status" centered>
                <div v-if="statuses[props.row.id]"><img src="@/assets/green2.png" style="width: 22px; padding-top: 9px" title="Online"></div>
                <div v-else-if="(statuses[props.row.id] === undefined)"><img src="@/assets/grey2.png" style="width: 20px; padding-top: 10px" title="No information"></div>
                <div v-else><img src="@/assets/red2.png" style="width: 20px; padding-top: 10px" title="Offline"></div>
            </b-table-column>
            <b-table-column centered>
              <b-button :disabled="role !== 'admin' && role !== 'device' && isMigrated" type="is-danger" @click="confirmReset(props.row.id)">Reset</b-button>
            </b-table-column>
          </template>
          <!-- <template slot="empty">
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <p>No devices to display.</p>
              </div>
            </section>
          </template> -->
        </b-table>
      </div>
    </section>
  </template>
<script>
/* eslint-disable */
  import axios from 'axios'
  
  export default {
    name: 'Devices',
    data: () => {
      return {
        tableData: [],
        selectedClusters: {},
        powerDevicesAddOn: false,
        selectedPowerDevices: {},
        statuses: {},
        falseBool: false
      }
    },
    computed: {
      devices () {
        return this.$store.state.devices
      },
      clusters () {
        return this.$store.state.clusters
      },
      powerDevices () {
        // return this.$store.state.powerDevices
        let powerDevices = this.$store.state.powerDevices
        var pds = []
        for (let powerDevice in powerDevices) {
          pds.push({ id: powerDevice, ...powerDevices[powerDevice] }) 
        }
        return pds.sort(this.compareNames)
      },
      addOns () {
        return this.$store.state.addOns
      },
      role () {
        return this.$store.state.role
      },
      userId () {
        return this.$store.state.uid
      },
      isMigrated () {
        return !this.getNotMigrated().includes(this.$store.state.uid)
      }
    },
    mounted: function () {
      if (this.$store.state.addOns !== null) {
        if (this.$store.state.addOns.powerDevices === true) {
          this.powerDevicesAddOn = true
        } else {
          this.powerDevicesAddOn = false
        }
      } else {
        this.powerDevicesAddOn = false
      }
      for (let device in this.devices) {
        if (device.charAt(2) === ':' || device.includes('-')) {
          this.tableData.push({ id: device, ...this.devices[device] })
          this.selectedClusters[device] = this.devices[device].clusterId ? this.devices[device].clusterId : ''
          // if (this.powerDevices) {
          this.selectedPowerDevices[device] = this.devices[device].powerDeviceId ? this.devices[device].powerDeviceId : ''
          // }
          this.statuses[device] = this.devices[device].online
        }
      }
      if (this.tableData.length > 0) {
        this.tableData.sort(this.compareNames)
      }
    },
    watch: {
      devices (devices) {
        this.tableData = []
        this.selectedClusters = {}
        this.selectedPowerDevices = {}
        for (let device in devices) {
          if (device.charAt(2) === ':' || device.includes('-')) {
            this.tableData.push({ id: device, ...this.devices[device] })
            this.selectedClusters[device] = this.devices[device].clusterId ? this.devices[device].clusterId : ''
            // if (this.powerDevices) {
            this.selectedPowerDevices[device] = this.devices[device].powerDeviceId ? this.devices[device].powerDeviceId : ''
              /* if (this.devices[device].powerDeviceId !== undefined) {
                this.selectedPowerDevices[device] = this.devices[device].powerDeviceId
              } else {
                this.selectedPowerDevices[device] = ''
              } */
            // }
            this.statuses[device] = this.devices[device].online
          }
        }
        if (this.tableData.length > 0) {    
          this.tableData.sort(this.compareNames)
        }
      }
    },
    methods: {
      changeDeviceCluster (event, id) {
        if (!this.getNotMigrated().includes(this.userId)) {
          this.$store.state.database.ref('/neoslide/devices/' + this.$store.state.workspaceId + '/' + id).update({
            clusterId: event.target.value
          })
        } else {
          this.$store.state.database.ref('/devices/' + this.$store.state.uid + '/' + id).update({
            clusterId: event.target.value
          })
        }
      },
      changePowerDevice (event, id) {
        if (!this.getNotMigrated().includes(this.userId)) {
          this.$store.state.database.ref('/neoslide/devices/' + this.$store.state.workspaceId + '/' + id).update({
            powerDeviceId: event.target.value
          })
        } else {
          this.$store.state.database.ref('/devices/' + this.$store.state.uid + '/' + id).update({
            powerDeviceId: event.target.value
          })
        }
      },
      confirmReset (id) {
        if (this.isMigrated) {
          if (this.role === 'admin' || this.role === 'device') {
            this.$buefy.dialog.confirm({
              title: 'Reset device',
              message: 'Are you sure you want to <b>reset</b> this device?',
              confirmText: 'Reset',
              type: 'is-danger',
              onConfirm: () => this.resetDevice(id)
            })
          }
        } else {
          this.$buefy.dialog.confirm({
            title: 'Reset device',
            message: 'Are you sure you want to <b>reset</b> this device?',
            confirmText: 'Reset',
            type: 'is-danger',
            onConfirm: () => this.resetDevice(id)
          })
        }
      },
      resetDevice (id) {
        let path = 'https://fcmtoken-utefbj56ha-uc.a.run.app/generateToken'
        axios.get(path)
        .then(response => {
          // JSON responses are automatically parsed.
          let accessToken = response.data
          let payload = {
            "message": {
              "notification":
              {
                "title": "reboot",
                "body": "reboot"
              },
              "token": this.$store.getters.getDevice(id).fcmID,
              "android": {
                "priority":"high"
              }
            }
          }
          if (accessToken !== 'ERROR') {
            let axiosConfig = {
              method: 'POST',
              url: 'https://fcm.googleapis.com/v1/projects/neods-c3270/messages:send',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
              },
              data: payload
            }
            axios(axiosConfig).then(response => {
              this.globalLogger(response, 'empty')
              this.$buefy.toast.open({
                duration: 5000,
                message: "Success"
              })
            })
            .catch(e => {
              // error alert
              this.$buefy.toast.open({
                duration: 5000,
                message: "An error occurred. Please try again."
              })
            })
          } else {
            this.$buefy.toast.open({
              duration: 5000,
              message: "An error occurred. Please try again."
            })
          }
        })
        .catch(e => {
          // error alert
          this.$buefy.toast.open({
            duration: 5000,
            message: "An error occurred. Please try again."
          })
        })
      },
      compareNames (a, b) {
        if (a.name < b.name) {
          return -1
        }
        if (a.name > b.name) {
          return 1
        }
        return 0
      }
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  


// WEBPACK FOOTER //
// src/components/devices/Devices.vue